export const API_ENDPOINTS = {
  SESSIONS: '/api/session',
  USERS: '/api/user',
  // ...
};

export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8080/';
